import { hash } from '@ember/helper';
import { service } from '@ember/service';

import CpPanel from 'ember-collapsible-panel/components/cp-panel/component';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsProductWorkComponent extends Component {
  // Services
  @service data;

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />
            <fieldset.field
              @property='cmsLanguageId'
              @type='select-value'
              @options={{this.availableLanguages}}
            />
            <fieldset.field @property='name' />
            <fieldset.field @property='level' @type='number' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='assignments' as |fieldset|>
            <fieldset.field
              @property='workContributors'
              @type='has-many-join'
              @hasManyForeignModelName='artist'
              @on={{hash openNewRecord=false removeRecord=this.deleteRelation}}
              as |contributor field|
            >
              <CpPanel @open={{contributor.isNew}} as |panel|>
                <panel.toggle>
                  {{svgJar
                    (if contributor.mainContributor 'star' 'star-outline')
                    class='u-icon'
                  }}
                  {{contributor.artist.displayLabel}}
                  {{#if contributor.category}}
                    -
                    {{contributor.category.name}}
                  {{/if}}
                </panel.toggle>
                <panel.body>
                  <Form @model={{contributor}} as |subform|>
                    <subform.field
                      @property='category'
                      @type='select-record'
                      @isSearchEnabled={{true}}
                      @options={{this.data.contributorCategories}}
                      @disabled={{field.isDisabled}}
                    />
                    <subform.field
                      @property='mainContributor'
                      @type='checkbox'
                    />
                  </Form>
                </panel.body>
              </CpPanel>
            </fieldset.field>
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
